import Configuration from '../configuration';
import { $httpProvider } from '../providers';

import mapKeys from 'lodash/mapKeys';
import camelCase from 'lodash/camelCase';
import snakeCase from '../utils/snake-case.util';
import deeply from '../utils/deeply.util';

function postReclamation(demande) {
  return $httpProvider()({
    method: 'POST',
    url: Configuration.postPrtv,
    data: deeply(mapKeys)(demande, (value, key) => snakeCase(key))
  }).then(r => deeply(mapKeys)(r.data, (value, key) => camelCase(key)));
}

function updateReclamation(demande) {
  return $httpProvider()({
    method: 'POST',
    url: Configuration.updatePrtv,
    data: deeply(mapKeys)(demande, (value, key) => snakeCase(key))
  }).then(r => deeply(mapKeys)(r.data, (value, key) => camelCase(key)));
}

function updateReclamationDemandeEnquete(demande) {
  return $httpProvider()({
    method: 'POST',
    url: Configuration.updatePrtvDemandeEnquete,
    data: deeply(mapKeys)(demande, (value, key) => snakeCase(key))
  }).then(r => deeply(mapKeys)(r.data, (value, key) => camelCase(key)));
}

function updateReclamationDemandeFacture(demande) {
  return $httpProvider()({
    method: 'POST',
    url: Configuration.updatePrtvWithFactureAntenniste,
    data: deeply(mapKeys)(demande, (value, key) => snakeCase(key))
  }).then(r => deeply(mapKeys)(r.data, (value, key) => camelCase(key)));
}

export default {
  postReclamation,
  updateReclamation,
  updateReclamationDemandeEnquete,
  updateReclamationDemandeFacture
};



// WEBPACK FOOTER //
// ./src/repositories/reclamation-prtv.repository.js